import { ArrowLeft, ShieldAlert } from "lucide-react";
import { type ReactNode } from "react";
import { Link } from "../lib/navigation.js";
import { Badge, Card } from "../components/ui/index.js";
import {
  type PayrollUser,
  sourceActivity,
  sourceActivityLabel,
} from "./payrollProfileModel.js";
export function SourceAccountBadge({ user }: { user: PayrollUser }) {
  const activity = sourceActivity(user);
  return (
    <span
      title={`OpenProject account: ${user.sourceAccountStatus ?? "unknown"}. Payroll import: ${user.isActive ? "included" : "excluded"}.`}
    >
      <Badge
        variant={
          activity === "active"
            ? "success"
            : activity === "inactive"
              ? "warning"
              : "outline"
        }
        dot
      >
        {sourceActivityLabel[activity]}
      </Badge>
    </span>
  );
}

export const AccessNotice = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <Card className="mx-auto max-w-2xl" elevated>
    <div className="flex items-start gap-3">
      <span className="rounded-xl bg-danger-subtle p-2 text-danger">
        <ShieldAlert aria-hidden="true" size={20} />
      </span>
      <div>
        <h1 className="text-lg font-semibold text-foreground">{title}</h1>
        <p className="mt-1 text-sm text-foreground-muted">{children}</p>
        <Link
          to="/"
          className="mt-4 inline-flex min-h-11 items-center gap-2 text-sm font-medium text-accent hover:text-accent-hover"
        >
          <ArrowLeft aria-hidden="true" size={16} /> Back to payroll
        </Link>
      </div>
    </div>
  </Card>
);
